/**
 * Maps a document `field_path` (`/customer`, `/lines/{line_key}/product`, ...) to the DOM
 * element id the review screen renders that field's container with. Used to jump from an alert
 * (`alerts/AlertsScreen.tsx`, which only carries a `reference_issue_id`) to the exact field on
 * the note it names - `docs/implementation/06-mobile-web.md` 6.5's "links back to the exact note
 * field". Pure and independently tested so the join between an alert and a rendered field is
 * one small verifiable rule rather than a scattered string template.
 */

const PRODUCT_FIELD_PATH = /^\/lines\/([^/]+)\/product$/;

/** The anchor id for `fieldPath`, or `null` for a field this screen does not currently render
 * with its own anchor (only the two reference fields - customer and each row's product - are
 * ever `ReferenceIssue.field_path` targets, per `app/references/repositories.py`'s
 * `open_issue_with_alert`). */
export function fieldAnchorId(fieldPath: string): string | null {
  if (fieldPath === '/customer') {
    return 'field-customer';
  }
  const match = PRODUCT_FIELD_PATH.exec(fieldPath);
  if (match?.[1] !== undefined) {
    return `field-product-${match[1]}`;
  }
  return null;
}
